// src/hooks/audience/useDomainActions.js
import { useCallback, useState } from "react";
import Api from "../../utils/Api";
import {
  API_ROUTE_AUDIENCE_CLASSIFICATION_MAP,
  API_ROUTE_AUDIENCE_CLASSIFICATION_REJECT,
} from "../../routes";

export function useDomainActions() {
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError] = useState("");

  // Domain selection is multi-select, so both actions take an array of ids and apply to all
  // of them - looped sequentially (not Promise.all) so actionLoading/actionError stay
  // meaningful for the whole batch instead of racing each other.
  const mapDomains = useCallback(async (domainIds, titleId, userId) => {
    setActionLoading(true);
    setActionError("");
    const failedIds = [];
    for (const domainId of domainIds) {
      try {
        await Api.put(
          API_ROUTE_AUDIENCE_CLASSIFICATION_MAP.replace("{id}", domainId),
          {
            titleId,
            userId,
          },
        );
      } catch {
        failedIds.push(domainId);
      }
    }
    setActionLoading(false);
    if (failedIds.length > 0) {
      setActionError(
        `Failed to map ${failedIds.length} of ${domainIds.length} domain(s).`,
      );
      return false;
    }
    return true;
  }, []);

  const rejectDomains = useCallback(async (domainIds, userId) => {
    setActionLoading(true);
    setActionError("");
    const failedIds = [];
    for (const domainId of domainIds) {
      try {
        await Api.put(
          API_ROUTE_AUDIENCE_CLASSIFICATION_REJECT.replace("{id}", domainId),
          {
            userId,
          },
        );
      } catch {
        failedIds.push(domainId);
      }
    }
    setActionLoading(false);
    if (failedIds.length > 0) {
      setActionError(
        `Failed to reject ${failedIds.length} of ${domainIds.length} domain(s).`,
      );
      return false;
    }
    return true;
  }, []);

  return {
    actionLoading,
    actionError,
    setActionError,
    mapDomains,
    rejectDomains,
  };
}
